export default [
	{
		label: "BC",
		name: "British Columbia",
		gateways: [
			{
				label: "Abbotsford",
				value: "YXX",
			},
			{
				label: "Kelowna",
				value: "YLW",
			},
			{
				label: "Vancouver",
				value: "YVR",
			},
			{
				label: "Victoria",
				value: "YYJ",
			},
		],
	},
	{
		label: "AB",
		name: "Alberta",
		gateways: [
			{
				label: "Calgary",
				value: "YYC",
			},
			{
				label: "Edmonton",
				value: "YEG",
			},
		],
	},
	{
		label: "SK",
		name: "Saskatchewan",
		gateways: [
			{
				label: "Regina",
				value: "YQR",
			},
			{
				label: "Saskatoon",
				value: "YXE",
			},
		],
	},
	{
		label: "MB",
		name: "Manitoba",
		gateways: [
			{
				label: "Winnipeg",
				value: "YWG",
			},
		],
	},
	{
		label: "ON",
		name: "Ontario",
		gateways: [
			{
				label: "Hamilton",
				value: "YHM",
			},
			{
				label: "Kitchener",
				value: "YKF",
			},
			{
				label: "London",
				value: "YXU",
			},
			{
				label: "North Bay",
				value: "YYB",
			},
			{
				label: "Ottawa",
				value: "YOW",
			},
			{
				label: "Sault Ste Marie",
				value: "YAM",
			},
			{
				label: "Sudbury",
				value: "YSB",
			},
			{
				label: "Thunder Bay",
				value: "YQT",
			},
			{
				label: "Toronto",
				value: "YYZ",
			},
			{
				label: "Windsor",
				value: "YQG",
			},
			{
				label: "Buffalo (US)",
				value: "BUF",
			},
		],
	},
	{
		label: "QC",
		name: "Québec",
		gateways: [
			{
				label: "Bagotville",
				value: "YBG",
			},
			{
				label: "Mont-Joli",
				value: "YYY",
			},
			{
				label: "Québec City",
				value: "YQB",
			},
			{
				label: "Montréal",
				value: "YUL",
			},
			{
				label: "Sept-Îles",
				value: "YZV",
			},
			{
				label: "Val d'Or",
				value: "YVO",
			},
		],
	},
	{
		label: "NF",
		name: "Newfoundland",
		gateways: [
			{
				label: "Deer Lake",
				value: "YDF",
			},
			{
				label: "Gander",
				value: "YQX",
			},
			{
				label: "St. John's",
				value: "YYT",
			},
			{
				label: "Stephenville",
				value: "YJT",
			},
		],
	},
	{
		label: "NB",
		name: "New Brunswick",
		gateways: [
			{
				label: "Fredericton",
				value: "YFC",
			},
			{
				label: "Moncton",
				value: "YQM",
			},
			{
				label: "Saint John",
				value: "YSJ",
			},
		],
	},
	{
		label: "PEI",
		name: "Prince Edward Island",
		gateways: [
			{
				label: "Charlottetown",
				value: "YYG",
			},
		],
	},
	{
		label: "NS",
		name: "Nova Scotia",
		gateways: [
			{
				label: "Halifax",
				value: "YHZ",
			},
		],
	},
];
